import "./carousel.scss";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const Carousel = ({
  elements = [],
  slidesPerView = 3,
  direction = "horizontal",
}) => {
  return (
    <Swiper
      direction={direction}
      slidesPerView={window.innerWidth > 800 ? 3 : "auto"}
      spaceBetween={16}
      loop={true}
      centeredSlides={true}
      autoplay={{
        delay: 1500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      pagination={{ clickable: true }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      {elements.map((element, index) => {
        return (
          <SwiperSlide
            key={`slide-${index}`}
            style={{
              width: "100%",
              height: "100%",
              maxWidth: window.innerWidth > 800 ? "100%" : "280px",
            }}
          >
            {element}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default Carousel;
